export enum Languages {
    fr = 'fr',
    en = 'en',
}

export enum LanguageUppercase {
    FR = 'FR',
    EN = 'EN',
}
